// One-time migration to add new scaffolding defects to existing settings
import { StorageService } from './storage'

export function migrateScaffoldingDefects() {
  if (typeof window === 'undefined') return

  const MIGRATION_FLAG = 'imki-scaffolding-defects-migrated'

  // Check if we already migrated
  if (localStorage.getItem(MIGRATION_FLAG)) {
    return
  }

  // Get current settings
  const settings = StorageService.getSettings()

  // Add new defects if they don't exist
  const updatedSettings = {
    ...settings,
    customDefects: {
      ...settings.customDefects,
      // Add new scaffolding defects if they don't exist
      ...(settings.customDefects?.scaffolding_distance ? {} : {
        scaffolding_distance: 'Gerüstabstand zur Fassade überschreitet 30cm (DIN 4420/EN 12811)'
      }),
      ...(settings.customDefects?.scaffolding_lift_placement ? {} : {
        scaffolding_lift_placement: 'Unzulässige Positionierung von Schrägaufzug auf Gerüstlage'
      })
    },
    geminiEnabledDefects: {
      ...settings.geminiEnabledDefects,
      // Enable new defects by default
      ...(settings.geminiEnabledDefects?.scaffolding_distance !== undefined ? {} : {
        scaffolding_distance: true
      }),
      ...(settings.geminiEnabledDefects?.scaffolding_lift_placement !== undefined ? {} : {
        scaffolding_lift_placement: true
      })
    }
  }

  // Save updated settings
  StorageService.saveSettings(updatedSettings)

  // Mark as migrated
  localStorage.setItem(MIGRATION_FLAG, 'true')
}